import type { AxiosRequestConfig } from 'axios'
import merge from 'lodash.merge'

import type { Obj, ID } from 'types/common'

import * as apiUtils from '.'

const url = '/sensor'

const headers = {
  'x-api-version': '1.1',
}

export const get = (id: ID, options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/${id}`, merge({}, { headers }, options))

export const getAll = (options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/`, merge({}, { headers }, options))

export const create = (data: Obj, options: AxiosRequestConfig = {}) =>
  apiUtils.POST(`${url}/`, data, merge({}, { headers }, options))

export const update = (id: ID, data: Obj, options: AxiosRequestConfig = {}) =>
  apiUtils.PUT(`${url}/${id}`, data, merge({}, { headers }, options))

export const remove = (id: ID, options: AxiosRequestConfig = {}) =>
  apiUtils.DELETE(`${url}/${id}`, merge({}, { headers }, options))

export const getCalibrationInfoForCable = (
  serial: ID,
  options: AxiosRequestConfig = {},
) =>
  apiUtils.GET(
    `${url}/calibration/cable/${serial}`,
    merge({}, { headers }, options),
  )

export const getCalibrationInfoForSite = (
  id: ID,
  options: AxiosRequestConfig = {},
) =>
  apiUtils.GET(`${url}/calibration/site/${id}`, merge({}, { headers }, options))

export const getByCable = (cableSerial: ID, options: AxiosRequestConfig = {}) =>
  apiUtils.GET(
    `${url}/`,
    merge({ params: { cableSerial } }, { headers }, options),
  )

export const getById = (id: ID, options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/`, merge({}, { params: { id } }, { headers }, options))

export type CalibratePayload = {
  serial: number
  notes: string | null
  operator: string | null
  eeprom: Array<{ id: string; pairedSensorId: string }> | null
  sensors: Array<{
    id: string
    offset: number
    position: number
  }>
}

export const calibrate = (
  data: CalibratePayload,
  options: AxiosRequestConfig = {},
) => apiUtils.POST(`${url}/calibrate`, data, merge({}, { headers }, options))
